import { Card, Typography } from '@material-ui/core'
import classes from './commentdetail.module.css';
import moment from 'moment';
import { Link } from 'react-router-dom'
import axios from 'axios';
import envUrls from '../../../utils/config';
import UseTime from '../../../hooks/useTime';
import { toast } from 'react-toastify';

let Commentdetail = (props) => {
    const notifyValidationsWarns = (msg) => {
        toast.clearWaitingQueue();
        toast(msg, {

            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: false,
        })
    };
    const parseList = (val) => {
        if (!val) return [];
        let items = [];
        if (Array.isArray(val)) {
            items = val.flatMap((item) => (typeof item === 'string' ? item.split(',') : item));
        } else if (typeof val === 'string') {
            items = val.split(',');
        }
        return items
            .map((s) => {
                if (typeof s !== 'string') return s;
                return s.replace(/[\]\['"]/g, '').trim();
            })
            .filter(Boolean);
    };

    const fileNames = parseList(props.filename);
    const fileLinks = parseList(props.file);

    let timestamp = UseTime(props.date)

    const dateFormat = timestamp
    const downloadAttachment = (fileKey) => {
        if (!fileKey) return;
        axios.get(envUrls.baseUrl + 'download_attachment?attachment=' + encodeURIComponent(fileKey)).then((res) => {
            console.log(res);
            window.open(res.data.donwload_url, 'Download')
        }).catch((err) => {
            console.log(err)
            if (err.response && err.response.status == 401 && sessionStorage.getItem('logging_out') !== 'true') {
                window.location.href = '/login'
                notifyValidationsWarns('Session expired, Please login again');
                sessionStorage.setItem('session_expired', 'true')
            }
        })
    }

    return (

        <Card elevation={8} className={classes.root} style={{ margin: '25px', backgroundColor: '#F2F2F2', borderRadius: '10px', padding: "7px 13px" }} >

            {
                props.type === 'close' ?
                    <Typography style={{ color: "#616168", fontWeight: 500, fontSize: "10px" }} variant="h6"> Closing comment</Typography> : ""
            }
            {
                props.type === 'reopen' ?
                    <Typography style={{ color: "#616168", fontWeight: 500, fontSize: "10px" }} variant="h6">Reopening comment</Typography> : ""
            }
            {
                props.type === 'Normal' ?
                    <Typography style={{ color: "#616168", fontWeight: 500, fontSize: "5px" }} variant="h6">Additional comment</Typography> : ""
            }
            <Typography variant="body2" style={{ color: "#616168" }}>By {props.author} on {dateFormat}</Typography>
            <Typography variant="subtitle2" style={{ paddingTop: "7px", color: 'black', whiteSpace: 'pre-wrap' }}>
                {props.comment}
                {fileNames.map((val, idx) => (
                    <span
                        key={idx}
                        style={{ color: 'blue', cursor: 'pointer', display: 'block', width: 'fit-content' }}
                        onClick={() => downloadAttachment(fileLinks[idx] || fileLinks[0])}
                    >
                        {val}
                    </span>
                ))}
            </Typography>
        </Card >
    )
}
export default Commentdetail